import { render, staticRenderFns } from "./informationIpad.vue?vue&type=template&id=75a6c055&scoped=true&"
import script from "./informationIpad.vue?vue&type=script&lang=js&"
export * from "./informationIpad.vue?vue&type=script&lang=js&"
import style0 from "./informationIpad.vue?vue&type=style&index=0&id=75a6c055&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75a6c055",
  null
  
)

export default component.exports